import React from 'react'
import "./Deposite_bar.css"

function Deposite_bar() {
  return (
  <>
  <section className="Deposite_bar">
  <div className="method">
    Recharge Method: <br/>
    <span>Phonepe_QR</span>
  </div>

  <button className="btn_register_bg">
    Deposit ₹100.00
  </button>
</section>
  </>
  )
}

export default Deposite_bar